import axiosInstance from '../../utils/axiosInstance';
const API_URL = process.env.REACT_APP_API_SETTINGS;

export const getInvoiceConfigs = async () => {
  const response = await axiosInstance.get(`${API_URL}/invoice`);
  return response.data;
};

export const createInvoiceConfig = async (invoiceConfig) => {
  const response = await axiosInstance.post(`${API_URL}/invoice`, invoiceConfig);
  return response.data;
};

export const updateInvoiceConfig = async (id, invoiceConfig) => {
  const response = await axiosInstance.put(`${API_URL}/invoice/${id}`, invoiceConfig);
  return response.data;
};

export const getRoles = async () => {
  const response = await axiosInstance.get(API_URL);
  return response.data;
};

export const createRole = async (role) => {
  const response = await axiosInstance.post(API_URL, role);
  return response.data;
};

export const updateRole = async (id, role) => {
  const response = await axiosInstance.put(`${API_URL}/${id}`, role);
  return response.data;
};

export const deleteRole = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/${id}`);
  return response.data;
};

export const getModules = async () => {
  const response = await axiosInstance.get(`${API_URL}/modules`);
  return response.data;
}

export const createModule = async (data) => {
  const response = await axiosInstance.post(`${API_URL}/modules`, data);
  return response.data;
}

export const getAvalaraSettings = async () => {
  const response = await axiosInstance.get(`${API_URL}/avalara`);
  return response.data;
}

export const createAvalaraSetting = async (data) => {
  const response = await axiosInstance.post(`${API_URL}/avalara`, data);
  return response.data;
}

export const updateAvalaraSetting = async (id, data) => {
  const response = await axiosInstance.put(`${API_URL}/avalara/${id}`, data);
  return response.data;
}

export const activateAvalaraSetting = async (id) => {
  const response = await axiosInstance.put(`${API_URL}/avalara/activate/${id}`);
  return response.data;
}
